export const CA_STATES = {
  AB: 'caState.name.alberta',
  BC: 'caState.name.britishColumbia',
  MB: 'caState.name.manitoba',
  NB: 'caState.name.newBrunswick',
  NL: 'caState.name.newfoundlandAndLabrador',
  NS: 'caState.name.novaScotia',
  NT: 'caState.name.northwestTerritories',
  NU: 'caState.name.nunavut',
  ON: 'caState.name.ontario',
  PE: 'caState.name.princeEdwardIsland',
  QC: 'caState.name.quebec',
  SK: 'caState.name.saskatchewan',
  YT: 'caState.name.yukon'
}
